export const baseUrl ='https://api.themoviedb.org/3';
export const API_KEY ='8b11869f895b51d9ca33a7aba044360e';
export const imageUrl = 'https://image.tmdb.org/t/p/original'

